import axios from "axios";
import { API_URL } from "./config";

/**
 * Axios client responsible to work with our API
*/
//uncomment and comment out export const axiosApi... for testing purposes
// const axioslnstance = axios.create({
//   baseURL: API_URL,
// });


// axioslnstance.interceptors.request.use(request => {
// console.log('Request:', JSON.stringify(request, null, 2))
// return request
// })
// axioslnstance.interceptors.response.use(response => { console.log('Response:', JSON.stringify(response, null, 2))
//  return response
// })


// export const axiosApi = axioslnstance;

export const axiosApi = axios.create({
  baseURL: API_URL,
});

const DEFAULT_RETRY_DELAY_MS = 1000;
const MAX_RETRY_DELAY_MS = 30000;

/**
 * Converts a Retry-After header (delta-seconds or HTTP-date) into a bounded delay in ms.
 * The value comes from a remote server, so it is validated and clamped before use.
 */
const getRetryDelayMs = (retryAfter: unknown): number => {
  if (typeof retryAfter !== "string" && typeof retryAfter !== "number") {
    return DEFAULT_RETRY_DELAY_MS;
  }

  const value = String(retryAfter).trim();
  let delayMs: number;

  if (/^\d+$/.test(value)) {
    delayMs = Number(value) * 1000;
  } else {
    const retryDate = Date.parse(value);
    delayMs = Number.isNaN(retryDate) ? DEFAULT_RETRY_DELAY_MS : retryDate - Date.now();
  }

  if (!Number.isFinite(delayMs)) {
    return DEFAULT_RETRY_DELAY_MS;
  }

  return Math.min(Math.max(Math.floor(delayMs), 0), MAX_RETRY_DELAY_MS);
};

// Add response interceptor to handle 429 (Too Many Requests) with Retry-After
axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    // Check if error is 429 and we haven't already retried
    if (error.response?.status === 429 && !config._retry) {
      config._retry = true;

      // Get a validated, bounded delay from the Retry-After header
      const delayMs = getRetryDelayMs(error.response.headers["retry-after"]);

      // Wait for the specified duration
      await new Promise<void>((resolve) => {
        setTimeout(() => resolve(), delayMs);
      });

      // Retry the request
      return axiosApi(config);
    }

    return Promise.reject(error);
  }
);



